import { Label, PrimaryButton, Stack, Text } from "@fluentui/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { handleInputCheck } from "../../common/invalidCharCheck";
import { addStation } from "../../reducers/diningReducer";
import styles from "../../styles/stationSelector.module.css";

type AddStationInputs = {
  newStationName: string;
};

export const AddStation = () => {
  const dispatch = useDispatch();
  const { handleSubmit, register, errors, reset, watch } = useForm<AddStationInputs>();
  const [invalidCharError, setInvalidCharError] = useState("");
  const inputValue = watch("updatedStationName");
  const onSubmit = (data: AddStationInputs) => {
    dispatch(addStation(data.newStationName));
    reset({ newStationName: "" });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Stack horizontal={true} verticalAlign={"end"} wrap={true} tokens={{ childrenGap: 10 }}>
          <Stack.Item grow>
            <Label>Add a station</Label>
            <input
              className={errors?.newStationName?.message ? styles.textInputBoxError : styles.textInputBox}
              type={"text"}
              defaultValue={""}
              placeholder={"New station name"}
              aria-label={"New station name"}
              aria-invalid={errors.newStationName ? "true" : "false"}
              name={"newStationName"}
              onChange={(e) => setInvalidCharError(handleInputCheck(e.target.value))}
              ref={register({
                required: { value: true, message: "This item needs a name." },
                minLength: { value: 2, message: "Can you be more descriptive?" },
                maxLength: {
                  value: 50,
                  message: "Too many characters.",
                },
              })}
            />
            {invalidCharError && <p className={styles.errorMessage}>{invalidCharError}</p>}
          </Stack.Item>
          <PrimaryButton text={"Add"} type={"submit"} disabled={inputValue == ""} />
        </Stack>
        {errors?.newStationName?.message && (
          <Text role={"alert"} className={styles.errorMessage}>
            {errors?.newStationName?.message}
          </Text>
        )}
      </div>
    </form>
  );
};
